import { createSlice } from "@reduxjs/toolkit";

export const spotsListSlice = createSlice({ //reducers for both hours in global state
    name: 'spotsList',
    initialState:{},
    reducers: {
        setSpotsList: (currentState, action) => {
            return action.payload
        }
    }
});